var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account"},[_c('h4',{staticClass:"account-title"},[_vm._v("Account Settings")]),_c('account-menu',{staticClass:"navigation-menu",on:{"scrollTo":_vm.onMenuItemSelect}}),_c('account-form',{staticClass:"account-forms"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }